import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

type StyledLinkProps = {
  to: string;
  children: React.ReactNode;
};

const StyledLink: React.FC<StyledLinkProps> = ({ to, children }) => (
  <Link
    to={to}
    style={{
      color: '#1976d2',
      textDecoration: 'none',
      fontWeight: 500,
      fontSize: '1.1rem',
      padding: '8px 0',
      borderRadius: '4px',
      transition: 'background 0.2s',
      marginBottom: '4px',
      display: 'inline-block',
    }}
    onMouseOver={e => (e.currentTarget.style.background = '#e3f2fd')}
    onMouseOut={e => (e.currentTarget.style.background = 'transparent')}
  >
    {children}
  </Link>
);

// Simple placeholder for the Exams tab; extend with actual tools/settings later
const AdminExams: React.FC = () => {
  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
         <h2> Create Exams </h2> 
            <StyledLink to="/ann-exam/v5">Create Exams v5</StyledLink>
            <StyledLink to="/ann-exam/v5baby">Create Exams v5baby</StyledLink>

         <h2> Browse Exams </h2> 

            <StyledLink to="/ann?showexams=v5">Exams v5</StyledLink>
            <StyledLink to="/ann?showexams=v5baby">Exams v5baby</StyledLink>
      </Box>
    </Box>
  );
};

export default AdminExams;
